import React from "react";
import Card from "@/components/Card";

import Commission from "./Commission";
import PurchaseSize from "./PurchaseSize";
import { Form, InputNumber } from "antd";
import { useRootSelector } from "@/infrastructure/hooks";
import { BacktestAction, BacktestSel } from "@/features/backtest";
import { useDispatch } from "react-redux";

export default () => {
  const dispatch = useDispatch();
  const cash = useRootSelector(BacktestSel.cash);

  return (
    <Card title={"Broker Options"}>
      <Form.Item
        label="Available Cash ($)"
        name={"cash"}
        rules={[{ required: true, message: "Please enter available cash!" }]}
        initialValue={cash}
      >
        <InputNumber
          style={{ width: "250px" }}
          onChange={e => dispatch(BacktestAction.updateSetup({ cash: e ? parseFloat(e as string) : 0 }))}
        />
      </Form.Item>
      <PurchaseSize />
      <Commission />
    </Card>
  );
};
